import React from 'react'

import InputSlider from '~/components/InputSlider'
import { VariableProductState } from '~/pages/LandingPage/VariableProductState'

import { addBasketItem } from '~/utils'
import { getProductsRef } from '~/firebase'
import { Product, VariableProduct } from '~/types'

import './style.css'


export default class LandingPage extends React.Component {
  state = {
    products: [] as Product[],
  }

  static contextTypes = {
    router: () => null // hack PropTypes return value
  }

  componentDidMount() {
    getProductsRef()
      .orderByChild('available')
      .equalTo(true)
      .once('value', snapshot => this.setState({products: snapshot!.val()}))
  }

  addToBasket = ({currentTarget}: {currentTarget: HTMLButtonElement}) => {
    addBasketItem(currentTarget.value)
    currentTarget.classList.add('clicked')
    setTimeout(() => {
      currentTarget.classList.add('effect')
      currentTarget.classList.remove('clicked')
    }, 1)
    setTimeout(() => {
      currentTarget.classList.remove('effect')
    }, 2000) // also change transition duration in css
  }

  renderVariableProduct = () => {
    const p = this.state.products[0] as VariableProduct

    if (!p) return null

    const datePurchased = new Date()
    const dateExpires = new Date(
      datePurchased.getFullYear(),
      datePurchased.getMonth() + p.duration,
      datePurchased.getDay()
    )

    return (
      <>
        <h1 className="isoComponentTitle sc-jzJRlG kviPuT" data-rtl="ltr">Choose your own</h1>
        <VariableProductState basePrice={p.basePrice} coefficient={p.coefficient}>
          {
            ({mhs, price, updateMhs}) => (
              <section className="ant-row full variableProduct">
                <div
                  className="ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24"
                  style={{height: 130, minWidth: 490, marginBottom: 16}}
                >
                  <div className="purchaseCard isoWidgetsWrapper sc-jzJRlG bAoCRe">

                    <article
                      className="isoStickerWidget sc-jKJlTe gbcuIV landingProduct"
                      style={{backgroundColor: `rgb(228, 228, ${255 - 0 / 2})`}}
                    >
                      <div className="isoBlockWrapper dates">
                        <time className="datePurchased" title="Duration in months">
                          <div>{p.duration}</div>
                          <div>months</div>
                        </time>
                        <time className="dateExpires" title="Expected expiration date">
                          <div>{dateExpires.toLocaleDateString()}</div>
                        </time>
                      </div>
                      <div className="isoBlockWrapper hashrate" title="Computing power">
                        <div className="hashrate">{mhs}</div>
                        <div className="hashunitWrapper">
                          <div className="hashunit">MH/s</div>
                        </div>
                      </div>
                      <div className="isoContentWrapper" title={JSON.stringify(p, null, ' ')}>
                        <div><span className="isoStatNumber">{p.name}</span><span/></div>
                        <figure>
                          <InputSlider
                            defaultValue={p.defaultComputingPower}
                            max={p.maxComputingPower}
                            onChange={updateMhs}
                          />
                        </figure>
                      </div>
                      <div className="isoBlockWrapper hashrate price" title="Price">
                        <div className="hashrate">{price.toFixed(0)}</div>
                        <div className="hashunitWrapper">
                          <div className="hashunit">€</div>
                        </div>
                        <div className="hashunitWrapper">
                          <br/>
                          <br/>
                          <div className="hashunit">@ {(price / mhs).toFixed(2)}</div>
                        </div>
                      </div>
                      <button className="isoCartWrapper" title="Purchase" value={-mhs} onClick={this.addToBasket}>
                        <i className="ion-android-cart"/>
                      </button>
                    </article>

                  </div>
                </div>
              </section>
            )
          }
        </VariableProductState>
      </>
    )
  }

  renderProducts = () => (
    <section className="ant-row full">
      {
        this.state.products.slice(1).map((p: Product, key) => {
          key++ // needs to be increased because of slice
          const datePurchased = new Date()
          const dateExpires = new Date(
            datePurchased.getFullYear(),
            datePurchased.getMonth() + p.duration,
            datePurchased.getDay()
          )

          return (
            <div key={key}
              className="ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-12"
              style={{height: 130, minWidth: 490, marginBottom: 16}}
            >
              <div className="purchaseCard isoWidgetsWrapper sc-jzJRlG bAoCRe">

                <article
                  className="isoStickerWidget sc-jKJlTe gbcuIV landingProduct"
                  style={{backgroundColor: `rgb(228, 228, ${255 - 0 / 2})`}}
                >
                  <div className="isoBlockWrapper dates">
                    <time className="datePurchased" title="Duration in months">
                      <div>{p.duration}</div>
                      <div>months</div>
                    </time>
                    <time className="dateExpires" title="Expected expiration date">
                      <div>{dateExpires.toLocaleDateString()}</div>
                    </time>
                  </div>
                  <div className="isoBlockWrapper hashrate" title="Computing power">
                    <div className="hashrate">{p.computingPower}</div>
                    <div className="hashunitWrapper">
                      <div className="hashunit">MH/s</div>
                    </div>
                  </div>
                  <div className="isoContentWrapper" title={JSON.stringify(p, null, ' ')}>
                    <div><span className="isoStatNumber">{p.name}</span><span/></div>
                    <figure>
                      {p.description}
                    </figure>
                  </div>
                  <div className="isoBlockWrapper hashrate price" title="Price">
                    <div className="hashrate">{p.price}</div>
                    <div className="hashunitWrapper">
                      <div className="hashunit">€</div>
                    </div>
                  </div>
                  <button className="isoCartWrapper" title="Purchase" value={key} onClick={this.addToBasket}>
                    <i className="ion-android-cart"/>
                  </button>
                </article>

              </div>
            </div>
          )
        })
      }
    </section>
  )

  render() {
    return (
      <div className="isoLayoutContentWrapper sc-kgoBCf gdNOpB">

        <section className="ant-row larger">
          <div className="ant-col-xs-24 ant-col-sm-24 ant-col-md-24" style={{paddingLeft: 8, paddingRight: 8, marginBottom: 16}}>
            <div className="isoBoxWrapper sc-chPdSV cOTLJI">
              <div>
                <h3 className="isoBoxTitle sc-cSHVUG ifvfLf">Landing page overview</h3>
                <p className="isoBoxSubTitle sc-kAzzGY gCwUWQ">This is just a bare example Landing page to allow simple <i>purchases</i>. This is not the final style.</p>
              </div>
            </div>
          </div>
        </section>

        <this.renderVariableProduct/>

        <h1 className="isoComponentTitle sc-jzJRlG kviPuT" data-rtl="ltr">Products</h1>
        <this.renderProducts/>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/LandingPage/index.tsx